var Constants = {
  QUERY_MODE_TRIM_GET: 'trim',
  QUERY_MODE_PAGING: 'page',
  QUERY_MODE_ALL: 'all',
  QUERY_MODE_SHIFT: 'shift',
  //
  PLAN_COPY_TYPE_WEEK: 1,
  PLAN_COPY_TYPE_REPEAT_MONTH: 2,
  PLAN_COPY_TYPE_DAY: 3,
  //
  StatusColors: {
    DEFAULT: '#00AAEE',
    REPORTED: '#a2bb48',
    REPORTE_COMPLETED: '#009999',
    APPROVED: '#EE0077',
    SELECTED: '#808080'
  },
  Code: {
    PlanStatus: {
      UNIMPLEMENTED: '000',
      REPORTED: '030',
      DYNAMIC_REPORTED: '033',
      REPORTE_COMPLETED: '035',
      APPROVED: '040'
    },
    PlanStatusList: {
      '000': '未実施',
      '030': '一部報告済',
      '033': '報告済',
      '035': '報告済',
      '040': '承認済'
    },
    PERIOD_OF_DAY: '04',
    PREFECTURE: '05',
    SEX: '06',
    ADDITION: '09',
    SPECIFIC_OFFICE_ADDITION_CD: '10',
    ServiceType: {
      UNIQUE_CODE: '1190'
    }
  },
  FunctionMask: {
    TAXI: 1,
    F1: 2,
    SAKURA: 4,
    KaigoNoMori: 8,
    NATIVE_CODE: 16,
    TeresaStandard: 32
  }
}

Object.freeze(Constants)

export default Constants
